// API
import { jsonApiAxios } from '../api';

interface DocumentUploadEmailRequest {
  claim: {
    id: string;
  };
}

export const documentUploadEmailSchema = {
  attributes: ['claim'],
  claim: {
    ref: 'id',
  },
};

/**
 * Generate a emailToken string in backend with the claimId
 * @returns AxiosResponse<DocumentUploadEmailTokenResponse> | Response
 */
export const generateNewEmailToken = (
  requestData: DocumentUploadEmailRequest,
  token?: string
) => {
  return jsonApiAxios.post('/documentUploadEmailTokens', requestData, {
    schema: documentUploadEmailSchema,
    type: 'documentUploadEmailTokens',
    ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
  });
};
